// extracted by mini-css-extract-plugin
export var infoRow = "_t1-2";
export var labelContainer = "_t1-0";
export var rightInfo = "_t1-1";